import React, { memo, useEffect, useMemo, useRef } from 'react'
import { useRouteMatch } from 'react-router'
import { getDevicePlatform, useInstallPWA } from '@frontend/pole-pwa'
import { PwaNotification, usePwaNotificationStore } from '@/components/composed/pwa/Notification'
import { ECommonRoute } from '@/types'

function AppPWANotification() {
  const {
    shouldShowInstallationPrompt,
    showNativeInstallationPrompt,
    triggerPWAInstall,
    canInstallNativeApp,
    resetPWAInstallationTrigger,
  } = useInstallPWA()

  const { methods, state } = usePwaNotificationStore()
  const timerRef = useRef<NodeJS.Timeout | null>(null)
  const isMobileDevices = getDevicePlatform() === 'iOS' || getDevicePlatform() === 'Android'
  const match = useRouteMatch(ECommonRoute.main)

  const shouldShowNotification = useMemo(() => {
    return isMobileDevices && shouldShowInstallationPrompt && canInstallNativeApp
  }, [isMobileDevices, shouldShowInstallationPrompt, canInstallNativeApp])

  useEffect(() => {
    if (state.isDismissed || !isMobileDevices || !canInstallNativeApp || !match?.isExact) return

    timerRef.current = setTimeout(() => {
      triggerPWAInstall()
    }, 3000)

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [canInstallNativeApp, isMobileDevices, match?.isExact, methods, state.isDismissed, triggerPWAInstall])

  if (!isMobileDevices || !match?.isExact) return null

  return (
    <PwaNotification
      resetPwaState={resetPWAInstallationTrigger}
      shouldShow={shouldShowNotification}
      showNativePrompt={showNativeInstallationPrompt}
      isIos={getDevicePlatform() === 'iOS'}
    />
  )
}

export default memo(AppPWANotification)
